export const months = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sept',
	'Oct',
	'Nov',
	'Dec',
];

const monthsMapping: { [key: string]: string } = {
	January: 'Jan',
	February: 'Feb',
	March: 'Mar',
	April: 'Apr',
	May: 'May',
	June: 'Jun',
	July: 'Jul',
	August: 'Aug',
	September: 'Sept',
	October: 'Oct',
	November: 'Nov',
	December: 'Dec',
};

export const monthFormat = (monthsToFormat: Array<string> | null = []) => {
	if (!monthsToFormat || monthsToFormat.length === 0) {
		return null;
	}

	let length = 1;
	const list: Array<string> = [];
	const indexMap = monthsToFormat
		.map((month) => months.indexOf(monthsMapping[month]))
		.sort((a, b) => a - b);
	// eslint-disable-next-line no-plusplus
	for (let i = 1; i <= indexMap.length; i++) {
		if (i === indexMap.length || indexMap[i] - indexMap[i - 1] !== 1) {
			if (length === 1) {
				list.push(months[indexMap[i - length]]);
			} else {
				list.push(`${months[indexMap[i - length]]}-${months[indexMap[i - 1]]}`);
			}

			length = 1;
		} else {
			length += 1;
		}
	}

	if (list.length === 1) {
		return list[0];
	}

	const last = list.pop();
	return `${list.join(', ')} and ${last}`;
};
